<template>
  <v-app>

    <core-toolbar />

    <core-drawer />

    <v-content>
      <div id="core-view">
        <v-fade-transition mode="out-in">
          <slot />
        </v-fade-transition>
      </div>
      <core-footer />
    </v-content>

    <safety-sponsor-modal />
    <safety-protocol-upsert-modal />
    <safety-site-upsert-modal />
    <safety-protocol-site-upsert-modal />
    <safety-treatment-upsert-modal />
    <safety-external-user-upsert-modal />
    <safety-adverse-event-mandatory-modal />

    <safety-change-password-modal/>

    <safety-snackbar />
    <safety-loader />

  </v-app>
</template>

<script>
export default {};
</script>

<style lang="scss">
@use "@/styles/index.scss";

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>